/**
 * Extract the directedId from the holmes cookie.
 * The holmes cookie is a JSON string containing user information.
 *
 * @param holmesCookie - The raw holmes cookie value
 * @returns The directedId if present, undefined otherwise
 */
export const getDirectedIdFromHolmesCookie = (holmesCookie: string | undefined): string | undefined => {
  if (!holmesCookie) {
    return undefined;
  }

  try {
    return JSON.parse(holmesCookie)?.directedId;
  } catch {
    // ignore malformed holmes cookie
    return undefined;
  }
};
